export const changePhotoInLocalStorage = (photo: string) => {
  const user = localStorage.getItem('hub71_user');
  const userCopy = { ...JSON.parse(user || '{}'), photo };
  localStorage.setItem('hub71_user', JSON.stringify(userCopy));
}

export default null;
